import React from "react";
import { createTopicShareLink } from "../api";
import { track } from "../utils/analytics";
import useShareLink, { shareTopicUrl, shareButtonStyle, shareButtonLabel } from "../hooks/useShareLink";

/**
 * ShareTopicButton — admin-only "⤴ Share" in the topic header.
 *
 * POSTs /api/topics/<id>/share/ (idempotent get-or-create of the topic's
 * share token), then hands the /t/<token> URL to useShareLink (share sheet on
 * touch, clipboard on desktop). The server decides shareability — a 400
 * (unpublished / institute / unsupported type) shows inline under the button.
 */
export default function ShareTopicButton({ topicId, step }) {
  const { shareState, error, share } = useShareLink();

  const onClick = () => {
    track("topic-share-click", { step });
    share(async () => {
      const { share_token } = await createTopicShareLink(topicId);
      return shareTopicUrl(share_token, step);
    });
  };

  return (
    <div className="shrink-0 flex flex-col items-end">
      <button
        type="button"
        onClick={onClick}
        disabled={shareState === "busy"}
        className="flex items-center gap-1 px-2 py-1 text-xs rounded-md border transition-colors hover:brightness-110 disabled:opacity-60"
        style={shareButtonStyle(shareState)}
        title="Copy a public link — anyone can view this topic without an account"
      >
        {shareButtonLabel(shareState)}
      </button>
      {error && <p className="mt-1 text-[11px] text-red-600 max-w-[220px] text-right">{error}</p>}
    </div>
  );
}
